import { ZenObservable } from 'zen-observable-ts';
import { APIService, Tokens } from './API.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Amplify, Auth, I18n } from 'aws-amplify';
import { Hub, Logger } from 'aws-amplify';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { finalize, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'amplify-app';
  /** Declare subscription variable */
  private subscription: ZenObservable.Subscription | null = null;
  public tokens: Array<Tokens> = [];
  user: any;
  authListen: (data: any) => void;
  logger: Logger;
  navMenu: any = [];
  route: string;
  // ...
  constructor(
    private location: Location,
    private api: APIService,
    private http: HttpClient,
    private router: Router
  ) {
    router.events.subscribe((val: any) => {
      console.log('location.path()', location.path());

      if (location.path() != '') {
        this.route = location.path();
      } else {
        this.route = '/';
      }
      this.setActiveMenu(this.route);
    });
  }
  ngAfterViewInit() {
    this.initNavMenu();
  }

  private initNavMenu() {
    this.navMenu.push({ name: I18n.get('OCR +'), link: '/ocrPlus' });
    this.navMenu.push({
      name: I18n.get('Invoice Scan +'),
      link: '/ocrPlusInvoice',
    });
    this.navMenu.push({
      name: I18n.get('Invoice Scan (legacy)'),
      link: '/receiptPage',
    });
    // this.navMenu.push({ name: I18n.get('Table Scan'), link: '/ocrTable' });
    // this.navMenu.push({ name: I18n.get('Barcode Scan'), link: '/barcodePage' });
    this.navMenu.push({
      name: I18n.get('Passport Scan'),
      link: '/passportPage',
    });
    // this.navMenu.push({
    //   name: I18n.get('Resume Scan'),
    //   link: '/resumePage',
    // });
    // this.navMenu.push({ name: 'API', link: '/apiDoc' });
  }
  setActiveMenu(path: string) {
    for (var item of this.navMenu) {
      if (path.includes(item.link)) {
        item.active = true;
      } else {
        item.active = false;
      }
    }
  }

  async ngOnInit() {
    Amplify.Logger.LOG_LEVEL = 'INFO';
    this.logger = new Logger('AppComponent');

    this.user = await Auth.currentUserInfo();
    this.logger.info('user', this.user);
    this.authListen = this.authListener(this.logger);

    Hub.listen('auth', this.authListen);

    /* subscribe to new tokens being created */
    this.subscription = this.api
      .OnCreateTokensListener()
      .subscribe((event: any) => {
        const newToken = event.value.data.onCreateToken;
        this.tokens = [newToken, ...this.tokens];
      });
  }

  private authListener(logger: Logger) {
    return async (data) => {
      switch (data.payload.event) {
        case 'configured':
          // logger.info('the Auth module is configured');
          break;
        case 'signIn':
          this.user = await Auth.currentUserInfo();
          let url = `${environment.apiUrl}/getOrCreateSumitUser?companyID=${environment.companyID}`; //getOrCreateSumitUser
          const sumitUserRequest = this.http
            .post(url, this.user, {})
            .pipe(finalize(() => {}));
          sumitUserRequest.subscribe((sumitUser) => {
            console.log('sumitUser', sumitUser);
          });
          this.router.navigateByUrl('/user');
          // logger.info('user signed in');
          break;
        case 'signIn_failure':
          logger.error('user sign in failed');
          break;
        case 'signUp':
          // logger.info('user signed up');
          break;
        case 'signUp_failure':
          logger.error('user sign up failed');
          break;
        case 'confirmSignUp':
          // logger.info('user confirmation successful');
          break;
        case 'completeNewPassword_failure':
          logger.error('user did not complete new password flow');
          break;
        case 'autoSignIn':
          // logger.info('auto sign in successful');
          break;
        case 'autoSignIn_failure':
          logger.error('auto sign in failed');
          break;
        case 'forgotPassword':
          // logger.info('password recovery initiated');
          break;
        case 'forgotPassword_failure':
          logger.error('password recovery failed');
          break;
        case 'forgotPasswordSubmit':
          // logger.info('password confirmation successful');
          break;
        case 'forgotPasswordSubmit_failure':
          logger.error('password confirmation failed');
          break;
        case 'tokenRefresh':
          // logger.info('token refresh succeeded');
          break;
        case 'tokenRefresh_failure':
          logger.error('token refresh failed');
          break;
        case 'cognitoHostedUI':
          // logger.info('Cognito Hosted UI sign in successful');
          break;
        case 'cognitoHostedUI_failure':
          logger.error('Cognito Hosted UI sign in failed');
          break;
        case 'customOAuthState':
          // logger.info('custom state returned from CognitoHosted UI');
          break;
        case 'customState_failure':
          logger.error('custom state failure');
          break;
        case 'parsingCallbackUrl':
          // logger.info('Cognito Hosted UI OAuth url parsing initiated');
          break;
        case 'userDeleted':
          // logger.info('user deletion successful');
          break;
        case 'signOut':
          this.user = null;
          // logger.info('user signed out');
          break;
      }
    };
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = null;
  }
  showNavBar = false;
  name = 'Doc2txt';
  logoSrc = 'assets/images/d2t-logo-white.svg';
  hamburgerSrc = 'assets/images/Hamburger_icon_white.svg';
  openNavBar(): void {
    this.showNavBar = !this.showNavBar;
  }
}
